var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-none",attrs:{"small":"","color":"primary","disabled":_vm.btndisable},on:{"click":_vm.saveline}},[_vm._v("Save ")])
}
var staticRenderFns = []

export { render, staticRenderFns }